module.exports = __webpack_public_path__ + "static/media/Подготовка литературно одаренных.. Опыт регионов.pdf";